module.exports = __webpack_public_path__ + "img/AntislipStrip.e8fd04c5.png";